export function hasUsableBounds(bounds) {
  if (!Array.isArray(bounds) || bounds.length !== 2) {
    return false;
  }

  const [[south, west], [north, east]] = bounds;
  return [south, west, north, east].every((value) => Number.isFinite(Number(value)));
}

export function fitMapToBounds(map, bounds, options = {}) {
  if (!map || !hasUsableBounds(bounds)) {
    return false;
  }

  const fitOptions = {
    padding: [48, 48],
    maxZoom: 11,
    animate: false,
    ...options,
  };

  if (typeof map.fitBounds === "function") {
    map.fitBounds(bounds, fitOptions);
    return true;
  }

  if (typeof map.flyToBounds === "function") {
    map.flyToBounds(bounds, fitOptions);
    return true;
  }

  return false;
}

export function applyQueuedBounds(map, bounds, mapLoaded, clearNextBounds) {
  if (!mapLoaded) {
    return false;
  }

  const applied = fitMapToBounds(map, bounds);

  if (applied && typeof clearNextBounds === "function") {
    clearNextBounds();
  }

  return applied;
}
